module.exports = __webpack_public_path__ + "img/Icon-Tasks.2e91b330.svg";